import { IconButton } from '@oy/uidesktop';
import { BankMaintenanceSideModal } from 'src/pages/Disbursement/components/Maintenance/BankMaintenanceSideModal/BankMaintenanceSideModal';
import { ShortcutDisbursementProducts } from 'src/pages/Disbursement/components/ShortcutSideModal/constant';
import { ShortcutSideModal } from 'src/pages/Disbursement/components/ShortcutSideModal/ShortcutSideModal';
import { AutoReportProvider } from '../AutoReportFormSideModal/AutoReportProvider';
import styles from './RouterActionButton.module.css';
import { useApiDisburseListActionButton } from './useApiDisburseListActionButton';

const ApiDisburseListActionButton = () => {
  const { state, action } = useApiDisburseListActionButton();
  const {
    showVendorMaintenance,
    showSideModal,
    showShortcutSideModal,
    showAutoReportModal,
  } = state;

  const {
    handleToggleSideModal,
    closeShortcutSideModal,
    closeBankMaintenanceSideModal,
    openShortcutSideModal,
    setShowAutoReportModal,
    handleAutoReportModal,
    handleFaqModal,
  } = action;

  return (
    <>
      <IconButton
        isDedupe
        iconName="configs"
        color={IconButton.Color.Secondary}
        size={IconButton.Size.Medium}
        buttonType={IconButton.Type.SquareOutlined}
        className={styles.helpButton}
        onClick={openShortcutSideModal}
      />

      {showSideModal && (
        <BankMaintenanceSideModal
          source="button_api_disburse_list"
          show={showSideModal}
          handleToggleSideModal={closeBankMaintenanceSideModal}
        />
      )}

      <AutoReportProvider
        onClose={() => {
          setShowAutoReportModal(false);
          openShortcutSideModal();
        }}
        productName="API_DISBURSE"
        showSideModalParent={showAutoReportModal}
        isShowToggleActivated={true}
      >
        {showShortcutSideModal && (
          <ShortcutSideModal
            show={showShortcutSideModal}
            showVendorMaintenance={showVendorMaintenance}
            productName={ShortcutDisbursementProducts.API_DISBURSE}
            onClose={closeShortcutSideModal}
            handleToggleSideModal={handleToggleSideModal}
            handleAutoReportModal={handleAutoReportModal}
            handleFaqModal={handleFaqModal}
          />
        )}
      </AutoReportProvider>
    </>
  );
};
export default ApiDisburseListActionButton;
